// eslint-disable-next-line no-unused-vars
export const clubAbilities = (can: any) => {
  can('ADD', 'CLUB')
  can('MANAGE', 'CLUB')
  can('ADD', 'TOURNAMENT')
  can('EDIT', 'TOURNAMENT')
}
